export default class Product {
  /**
   * @type Element
   */
  product;

  /**
   * @type {number}
   */
  id = 0;

  /**
   * @type {number}
   */
  price = 0;

  /**
   * @type {number}
   */
  sum = 0;

  /**
   * @type {number}
   */
  count = 0;

  /**
   * @type {boolean}
   */
  wish = true;

  /**
   * @type {{PRICE: string, SUM: string, COUNT: string, WISH: string}}
   */
  SELECTORS = {
    PRICE: '[data-product-price]',
    SUM: '[data-product-sum]',
    COUNT: 'input[type="number"]',
    WISH: 'input[type="checkbox"]',
  };

  /**
   * Use to collect data about product
   * @param {HTMLElement} product
   */
  constructor(product) {
    this.product = product;
    this.id = Number(product.dataset.cartProductId);
    this.price = Number(product.querySelector(this.SELECTORS.PRICE).dataset.productPrice);
    this.sum = Number(product.querySelector(this.SELECTORS.SUM).dataset.productSum);
    this.count = Number(product.querySelector(this.SELECTORS.COUNT).value);
    this.wish = product.querySelector(this.SELECTORS.WISH).checked;
  }

  /**
   * Use for update content in html product.
   * @returns {Product}
   */
  update() {
    this.price = Number(this.product.querySelector(this.SELECTORS.PRICE).dataset.productPrice);
    this.count = Number(this.product.querySelector(this.SELECTORS.COUNT).value);

    const price = this.price * this.count;
    this.product.querySelector(this.SELECTORS.SUM).dataset.productSum = price.toString();
    this.product.querySelector(this.SELECTORS.SUM).textContent = price.toString();

    this.id = Number(this.product.dataset.cartProductId);
    this.sum = price;

    return this;
  }

  get Sum() {
    return this.sum;
  }

  get Count() {
    return this.count;
  }
}
